"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
const hu_json_1 = __importDefault(require("./hu.json"));
const en_json_1 = __importDefault(require("./en.json"));
exports.translations = { hu: hu_json_1.default, en: en_json_1.default };
